import React from 'react';
import PropTypes from 'prop-types';

const ExtendedFormCategory = (props) => {
  const {
    id,
    active,
    setCategory,
    title,
  } = props;

  return (
    <button
      type="button"
      className={`btn ${active ? 'btn--b' : 'btn--c'} btn--small mas twsn tac`}
      onClick={() => setCategory(id)}
    >
      {title}
    </button>
  );
};

ExtendedFormCategory.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.bool,
  setCategory: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ExtendedFormCategory.defaultProps = {
  active: false,
  title: '',
};

export default ExtendedFormCategory;
